import React, { useEffect , useState } from 'react'
import { useHistory } from 'react-router-dom'
import Navbar from '../../components/home/Navbar'
import Banner from '../../components/home/Banner'
import About from '../../components/home/About'
import Footer from '../../components/home/Footer'
import { setLogin } from '../../redux/actions/auth'
import Service from '../../components/home/Service'
import { useDispatch } from 'react-redux'
import queryString from "query-string";

const Home = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch({ type: "FROM_HOME_TRUE" })
        dispatch({type: "SET_PATH" , payload: {path: "/"}})
    }, [])

    const [mounted, setMounted] = useState(false)
    const history = useHistory()
    if (!mounted) {
        var query = queryString.parse(history.location.search);
        if(query) {
            if (query.payload) {
                const payload = JSON.parse(query.payload)
                dispatch(setLogin(payload))
                history.push('/auth/login')
            }
        }
    }


    return (
        <div className="pt-14 dark:bg-gray-800 text-gray-600 dark:text-gray-100">
            <Navbar />
            <Banner />
            <About />
            <Service />
            <Footer />
        </div>
    )
}

export default Home
